export default __webpack_public_path__ + "static/media/ai-leads.4c5aacab.svg";